'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isIE11 = exports.isIE11 = function isIE11() {
  return navigator.userAgent.indexOf('Trident/') >= 0;
};

var isEdge = exports.isEdge = function isEdge() {
  return navigator.userAgent.indexOf('Edge/') >= 0;
};

var isMS = exports.isMS = function isMS() {
  return isIE11() || isEdge();
};

var isFirefox = exports.isFirefox = function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf('firefox') >= 0;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/utils/BrowserTest.js
// module id = 167
// module chunks = 0